import { inject } from '@angular/core';
import { CanDeactivateFn } from '@angular/router';
import { NextFacade } from '../facade/next.facade';

export function nextCleanup<T>(): CanDeactivateFn<T> {
    return () => {
        const nextFacade = inject(NextFacade);
        nextFacade.clear();

        return true;
    };
}
